import {
  PromoDetail,
  PromoGroupCount,
  PromoGroupHighlights,
  PromoHighlights,
  Promos,
} from '@diamond/shared/types';
import { apiInstance, buyerCaptureException } from '@diamond/shared/utils';
import { InfiniteData } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

export const getPromoList = async (
  token: string,
  selectedShipToId: string,
  page = 1,
  size = 12,
  type = 'general'
): Promise<Promos> => {
  const url = '/promo/buyer';
  const { data } = await apiInstance(token).get<Promos>(url, {
    params: {
      warehouse: selectedShipToId,
      page,
      size,
      type,
    },
  });
  return data;
};

export const getPromoDetail = async (
  token: string,
  selectedShipToId: string,
  promoId: string
) => {
  const url = `/promo/buyer/${promoId}/detail`;
  const { data } = await apiInstance(token).get<PromoDetail>(url, {
    params: {
      warehouse: selectedShipToId,
    },
  });
  return data.data;
};

export const getPromoHighlights = async (token: string, warehouse: string) => {
  try {
    const url = '/promo/highlights';
    const { data } = await apiInstance(token).get<PromoHighlights>(url, {
      params: {
        warehouse,
      },
    });
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      buyerCaptureException(error.response?.data, (scope, user) => {
        scope.setTag('PromoHighlights', `Warehouse ${warehouse}`);
        scope.setUser({
          ...user,
          additional: {
            warehouse,
          },
        });
        scope.setLevel('error');
      });
    }
  }
  throw new Error('Error Get PromoHighlights');
};

export const getPromoCount = async (token: string, warehouse: string) => {
  try {
    const url = '/promo/counter-group';
    const { data } = await apiInstance(token).get<PromoGroupCount>(url, {
      params: {
        warehouse,
      },
    });
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      buyerCaptureException(error.response?.data, (scope, user) => {
        scope.setTag('PromoCount', `Warehouse ${warehouse}`);
        scope.setUser({
          ...user,
          additional: {
            warehouse,
          },
        });
        scope.setLevel('error');
      });
    }
  }
  throw new Error('Error Get PromoHighlights');
};

export const getPromoGroupHighlights = async (
  token: string,
  warehouse: string
) => {
  try {
    const { data } = await apiInstance(token).get<PromoGroupHighlights>(
      `/promo/highlights-group`,
      {
        params: { warehouse },
      }
    );
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      buyerCaptureException(error.response?.data, (scope, user) => {
        scope.setTag('PromoGroupHighlights', `Warehouse ${warehouse}`);
        scope.setUser({
          ...user,
          additional: {
            warehouse,
          },
        });
        scope.setLevel('error');
      });
    }
    throw new Error('Error Get PromoGroupHighlights');
  }
};
